
const Alert = (props) => {

    return ( <div {...props} >{props.children}</div>  );
}
 
export default Alert;